import { render, staticRenderFns } from "./product-reviews-modal.vue?vue&type=template&id=73a644ba&"
import script from "./product-reviews-modal.vue?vue&type=script&lang=js&"
export * from "./product-reviews-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports